import React from "react";
import { Clock, ShieldCheck } from "lucide-react";
import creditHistoryImage from "assets/expressReport/welcome/credit-history-welcome.png";

interface WelcomeProps {
  setStep: (step: number) => void;
}

const Welcome: React.FC<WelcomeProps> = ({ setStep }) => {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-4">
      {/* Hero Section */}
      <div className="mb-4 text-center">
        <h1 className="mb-3 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
          Historial Crediticio
        </h1>
        <p className="mx-auto max-w-xl text-sm text-slate-500 sm:text-base">
          Vamos a realizar el proceso de autorización de consulta a tu historial
          crediticio. Solo sigue las instrucciones. Da clic en el botón para
          comenzar.
        </p>
      </div>

      {/* Image */}
      <div className="mb-4 w-full max-w-sm">
        <div className="relative aspect-[4/3] overflow-hidden rounded-xl">
          <img
            src={creditHistoryImage}
            alt="Historial Crediticio"
            className="absolute inset-0 h-full w-full object-cover object-center"
          />
        </div>
      </div>

      {/* Features */}
      <div className="flex items-center justify-center gap-6 text-sm text-slate-500">
        <div className="flex items-center gap-2">
          <ShieldCheck className="h-4 w-4 text-emerald-500" />
          <span>Seguro y confiable</span>
        </div>
        <div className="h-4 w-px bg-slate-200" />
        <div className="flex items-center gap-2">
          <Clock className="h-4 w-4 text-blue-500" />
          <span>Solo 3 minutos</span>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
